import ApiService from '@services/api.service';
import { Notify } from 'quasar';
import { useStore } from 'vuex';
import Form from "@pages/Survey/Form.vue";

export const SchedulerEventEmargementEtudiants = {
  state: {
    eventSignatureStudents: [],
    eventSignatureStudent: null,
    objet: null
  },
  mutations: {
    setEventSignatureStudents(state, eventSignatureStudents) {
      state.eventSignatureStudents = eventSignatureStudents;
    },
    setEventSignatureStudent(state, eventSignatureStudent) {
      state.eventSignatureStudent = eventSignatureStudent;
    },
    callbackEditStudentEventSignature(state, payload) {
      state.objet = payload.objet;
    }
  },
  actions: {
    fetchEventsSignaturesBySignature(context, idSignature) {
      try {
        return ApiService.getRequest(`/scheduler_event_emargements/${idSignature}/emargement_etudiants`).then(
          response => {
            context.commit('setEventSignatureStudents', response.data['hydra:member']);
          });
      } catch (error) {
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },
    async fetchEventsEmargementsStudent(context, etudiant){
      return await ApiService.getRequest('/scheduler_event_emargement_etudiants', {etudiant: etudiant}).then(
        response => {
          context.commit('setEventSignatureStudents', response.data['hydra:member'])
        }
      ).catch((error) => {
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de la récupération des données",
          color:'red'
        })
      })
    },
    /* CRUD ÉMARGEMENTS (POST / PATCH) */
      // émargement des stagiaires
    async addStudentEventSignature({ context, dispatch }, data) {
      try {
        const response = await ApiService.postRequest('/scheduler_event_emargement_etudiants', data);
        this.commit('setEventSignatureStudent', response.data);
        if (data && data.sign_off_at !== null && data.status === 0) {
          data.absence.emargement = data.emargement;
          await dispatch('addEtudiantAbsence', data.absence);
        }
        if(data && data.sign_off_at !== null && data.status === 1){
          //Crée le pointage pour les bénéficiaires qui on tété renseigné comme présent
           await dispatch('addEtudiantPointagePresence', data);
        }

        return response.data;
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        console.error(error);
        return Promise.reject(error);
      }
    },
    async editStudentEventSignature({ context, dispatch }, data) {
      const store = useStore();
      try {
        const response = await ApiService.patchRequest(`/scheduler_event_emargement_etudiants/${data.id}`, data);
        this.commit('callbackEditStudentEventSignature', response.data);
        if (data && data.sign_off_at !== null && data.old_status_parent !== 2) {
          const absenceParams = {
            etudiantId: data.absence?.etudiant_id,
            dt_start:   data.absence_dates?.dt_start,
            dt_end:     data.absence_dates?.dt_end,
            hr_start:   data.absence_dates?.hr_start,  // ✅ heure de début de l'événement
            hr_end:     data.absence_dates?.hr_end,    // ✅ heure de fin de l'événement
          };

          const requiredParams = ['etudiantId', 'dt_start', 'dt_end', 'hr_start', 'hr_end'];
          const paramsAreValid = requiredParams.every(
            key => absenceParams[key] !== null && absenceParams[key] !== undefined
          );

          const absence = paramsAreValid
            ? await dispatch('fetchAbsenceByStudentAndDates', absenceParams)
            : null
          ;

          if (data.status === 0 && (absence == null || absence == undefined)) {
            data.absence.emargement = data.emargement;
            await dispatch('addEtudiantAbsence', data.absence);
          }

          function dateToISOString (date){
            const [day, month, year] = date.split('/');
            const dateObj = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));;
            return dateObj.toISOString();
          }

          if (data.status === 1 && absence !== undefined && absence !== null){
            //Réupere le pointage par l' id absence
            const pointageAbsence = await dispatch('fetchPointagesByAbsenceId', absence.id);
            if(pointageAbsence.length !== 0){
              let form = new FormData();
              form.append('pointage_id', pointageAbsence[0].id);
              form.append('etudiant_id', data.absence.etudiant_id);
              await ApiService.postRequest('/etudiant_pointage_delete_absence', form);
            }
            let dataForPointage = {
              etudiant: data.etudiant,
              emargement:data.emargement
            }
            const pointage = await dispatch('fetchPointageByEtudiantEmargement', dataForPointage);

            if (pointage[0] !== undefined && pointage[0] !== null) {
              //Modifie le pointage actuel vers un pointage de présence
              let dataPointage = {
                dateStart: dateToISOString(data.absence.dt_start),
                dateEnd: dateToISOString(data.absence.dt_end),
                hr_start: data.absence.hr_start,
                hr_end: data.absence.hr_end,
                pointageId: pointage[0].id,
                emargement: data.emargement,
                typePointage: "present",
              }

              await dispatch('updatePointage', dataPointage);
            }

            //création présence
            if(pointage.length === 0){
              let dataPointage = {
                dateStart: dateToISOString(data.absence.dt_start),
                dateEnd: dateToISOString(data.absence.dt_end),
                etudiant: data.absence.etudiant,
                emargement: data.emargement,
                typePointage: "present",
              }
              await dispatch('addEtudiantPointagePresence', dataPointage);
            }
            await ApiService.deleteRequest(`${absence['@id']}`);
          }
        }
        return response.data;
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        console.error(error);
        return Promise.reject(error);
      }
    }
  },
  getters: {
    getEventSignatureStudents(state) {
      return state.eventSignatureStudents;
    },
    getEventSignatureStudent(state) {
      return state.eventSignatureStudent;
    }
  }
}
